export type RouteType = {
  title: string
  path: string
}

export const Routes = {
  Home: {
    title: '',
    path: '/'
  },
  Help: {
    title: 'Help',
    path: '/help'
  },
  Search: {
    title: 'Search',
    path: '/search'
  },
  Account: {
    title: 'Account',
    path: '/account'
  },
  Privacy: {
    title: 'Privacy Policy',
    path: '/privacy'
  },
  Terms: {
    title: 'Terms',
    path: '/terms'
  },
  Admin: {
    title: 'Admin Page',
    path: '/admin'
  },
  Admin_OutsideRequest: {
    title: 'Outside Request List',
    path: '/admin/outside_request'
  },
  Admin_Outside: {
    title: 'Outside List',
    path: '/admin/outside'
  }
}
